const es = {
  common: {
    facts: "En cifras",
    why: "Por qué elegir el Hotel Ciutat Martorell",
    related: "También te puede interesar",
    quoteEyebrow: "Cuéntanos tu boda",
  },
  nearSeat: {
    seoTitle: "Hotel cerca de SEAT-CUPRA Martorell · a 5 min de la fábrica",
    seoDesc: "Hotel 4★ a 5 minutos de la fábrica SEAT-CUPRA y los polígonos de Martorell. Tarifas corporativas, WiFi de fibra, parking, restaurante y tren a 100 m.",
    eyebrow: "Hotel para visitas a SEAT-CUPRA",
    title: ["Tu hotel a 5 minutos", "de SEAT-CUPRA Martorell"],
    intro: "Proveedores, ingenieros, formadores y equipos de proyecto se alojan con nosotros porque la fábrica y los polígonos de Martorell están a un paso, y el tren a Barcelona a 100 metros.",
    facts: [
      { k: "Fábrica SEAT-CUPRA", v: "5 min en coche" },
      { k: "Renfe y FGC", v: "100 m" },
      { k: "Barcelona", v: "30 min" },
      { k: "Aeropuerto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Pensado para la estancia de trabajo", p: "Habitaciones de 21 m² con escritorio, WiFi de fibra gratuito y climatización. Desayuno buffet de 06:30 a 10:30 para llegar a tiempo al turno de mañana, recepción 24 h para llegadas tardías y Business Corner para imprimir o cerrar un informe." },
      { h: "Tarifas corporativas y facturación centralizada", p: "Para empresas que visitan la planta con regularidad ofrecemos tarifas negociadas, facturación centralizada y gestión ágil de las reservas de equipos. Cuéntanos el volumen aproximado de noches y te preparamos una propuesta." },
      { h: "Reuniones y formaciones junto a la fábrica", p: "Tres salas con luz natural de 35 a 220 m² para formaciones de proveedores, kick-offs o auditorías, con proyector, fibra y coffee break. Y el restaurante My Bar para comidas de trabajo, con menú ejecutivo de lunes a viernes." },
    ],
    why: [
      "A 5 minutos en coche de la fábrica SEAT-CUPRA y de los polígonos de Martorell",
      "Parking privado en el propio hotel (con suplemento)",
      "WiFi de fibra gratuito y escritorio en todas las habitaciones",
      "Desayuno desde las 06:30 y recepción 24 horas",
      "Tarifas corporativas con facturación centralizada",
    ],
    faqTitle: "Sobre alojarse cerca de SEAT-CUPRA",
    cta: { title: "Reserva directa o tarifa de empresa", text: "Reserva en la web oficial al mejor precio garantizado o solicita una tarifa corporativa para tu equipo.", secondary: "Tarifas para empresas", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Hotel para empresas" },
      { to: "meetingRooms", label: "Salas de reuniones" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "Dónde alojarse si visitas Martorell por trabajo" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hotel cerca de Montserrat · a 20 min del monasterio",
    seoDesc: "Hotel 4★ en Martorell a 20 minutos en coche de Montserrat y con tren FGC a 100 m hacia el cremallera. Base cómoda para visitar el monasterio y Barcelona.",
    eyebrow: "Hotel para visitar Montserrat",
    title: ["Montserrat a 20 minutos,", "Barcelona a 30"],
    intro: "Martorell es el punto medio perfecto: por la mañana el monasterio y las montañas de Montserrat, por la tarde Barcelona. Y por la noche, una habitación tranquila con restaurante y parking.",
    facts: [
      { k: "Monasterio de Montserrat", v: "20 min en coche" },
      { k: "Tren FGC al cremallera", v: "a 100 m del hotel" },
      { k: "Barcelona", v: "30 min" },
      { k: "Aeropuerto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Cómo llegar a Montserrat desde el hotel", p: "En coche, 20 minutos hasta el monasterio o hasta el aparcamiento del cremallera en Monistrol. En transporte público, la estación de FGC está a 100 metros: línea R5 hasta Monistrol de Montserrat y subida en cremallera, o hasta Montserrat-Aeri y subida en teleférico." },
      { h: "Un día en la montaña, una noche de descanso", p: "Después de la basílica, la Escolanía o una caminata hasta Sant Jeroni, vuelve a una habitación de 21 m² con climatización, baño con ducha y WiFi de fibra. Cena en el restaurante My Bar con cocina mediterránea de mercado y vinos del Penedès." },
      { h: "Combina Montserrat con Barcelona", p: "Desde las estaciones de Renfe y FGC, Barcelona está a unos 30 minutos. Puedes dedicar un día a Montserrat y otro a la ciudad sin cambiar de hotel ni pelearte con el aparcamiento del centro." },
    ],
    why: [
      "A 20 minutos en coche del monasterio de Montserrat",
      "Estación de FGC a 100 metros con conexión al cremallera y al teleférico",
      "Parking privado para dejar el coche y moverse en tren",
      "Restaurante My Bar con cocina mediterránea y vinos del Penedès",
      "Desayuno buffet de 06:30 a 10:30 para madrugar en la montaña",
    ],
    faqTitle: "Sobre visitar Montserrat desde el hotel",
    cta: { title: "Reserva tu base para Montserrat", text: "Reserva directa en la web oficial al mejor precio garantizado. Si venís en grupo, pedidnos una propuesta.", secondary: "Cómo llegar al hotel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "Cómo llegar a Montserrat desde Martorell" },
      { to: "location", label: "Ubicación y cómo llegar" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "Qué visitar cerca de Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hotel con parking cerca de Barcelona · a 30 min en tren",
    seoDesc: "Hotel 4★ con parking privado en Martorell, a 30 minutos de Barcelona. Deja el coche y entra en la ciudad en Renfe o FGC desde la estación a 100 m. Reserva directa.",
    eyebrow: "Hotel con parking",
    title: ["Aparca el coche,", "Barcelona en 30 minutos"],
    intro: "Si llegas en coche a Barcelona, dormir fuera del centro es más tranquilo y sencillo: parking privado en el hotel y tren directo a la ciudad a 100 metros de la puerta.",
    facts: [
      { k: "Parking privado", v: "en el hotel" },
      { k: "Estaciones Renfe y FGC", v: "100 m" },
      { k: "Barcelona centro", v: "30 min" },
      { k: "Aeropuerto El Prat", v: "25 min" },
    ],
    sections: [
      { h: "Parking privado en el propio hotel", p: "Plazas de aparcamiento privado para clientes alojados (con suplemento), sin buscar sitio ni pagar las tarifas de los parkings del centro de Barcelona. Entras y sales cuando quieres y el coche queda a dos pasos de tu habitación." },
      { h: "A Barcelona en tren, sin tráfico", p: "Las estaciones de Renfe (Rodalies) y FGC están a 100 metros. En unos 30 minutos estás en el centro; a la vuelta, el coche te espera. Para moverte por la provincia, la A-2 y la AP-7 están al lado." },
      { h: "Un hotel completo para la escapada", p: "92 habitaciones de 21 m² con WiFi de fibra, restaurante My Bar, gimnasio y desayuno buffet de 06:30 a 10:30. Ideal para familias y parejas que visitan Barcelona o Montserrat en coche." },
    ],
    why: [
      "Parking privado para huéspedes en el hotel",
      "Trenes a Barcelona a 100 metros: Renfe y FGC",
      "A 30 minutos de Barcelona y 25 del aeropuerto",
      "Habitaciones Doble y Twin de 21 m² con WiFi de fibra",
      "Restaurante, gimnasio y recepción 24 h",
    ],
    faqTitle: "Sobre el parking y cómo ir a Barcelona",
    cta: { title: "Reserva con parking y olvídate del coche", text: "Reserva directa en la web oficial al mejor precio garantizado e indícanos si vienes en coche.", secondary: "Servicios del hotel", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "Cómo ir de Martorell a Barcelona" },
      { to: "services", label: "Servicios del hotel" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Transportes entre Martorell y Barcelona" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Hotel para bodas en el Baix Llobregat · Martorell",
    seoDesc: "Celebra tu boda en Martorell: Salón de Banquetes hasta 150 invitados, cóctel hasta 200 en la terraza, menú degustación, habitación nupcial y tarifas para invitados.",
    eyebrow: "Bodas en el Baix Llobregat",
    title: ["Tu boda en el Baix Llobregat,", "con todo bajo un mismo techo"],
    intro: "Cóctel en la terraza, banquete en un salón de 220 m² con luz natural, cocina mediterránea propia y 92 habitaciones para que nadie tenga que conducir de vuelta. A 30 minutos de Barcelona y bien comunicado con toda la comarca.",
    facts: [
      { k: "Banquete", v: "hasta 150 invitados" },
      { k: "Cóctel", v: "hasta 200 personas" },
      { k: "Salón de Banquetes", v: "220 m² con luz natural" },
      { k: "Habitaciones", v: "92 para los invitados" },
    ],
    sections: [
      { h: "Espacios: terraza, salón y habitaciones", p: "El cóctel de bienvenida en la terraza, el banquete en el Salón de Banquetes panelable de 220 m² y, al terminar, la habitación nupcial de cortesía y tarifas especiales para los invitados que se queden a dormir." },
      { h: "Cocina propia y menú degustación", p: "Nuestro equipo de cocina prepara menús de boda a medida con producto mediterráneo de temporada y vinos del Penedès. Antes del gran día organizamos una degustación para cerrar cada plato con los novios." },
      { h: "Un coordinador desde el primer café", p: "Presupuesto cerrado en 48 horas, sin sorpresas. Un coordinador dedicado gestiona tiempos, proveedores, DJ y barra libre opcional para que la pareja solo tenga que disfrutar." },
    ],
    why: [
      "Bien comunicado para invitados de Barcelona y de toda la comarca: 30 min en coche y tren a 100 m",
      "Salón de 220 m² con luz natural y terraza para el cóctel",
      "Habitación nupcial de cortesía y tarifas especiales para invitados",
      "Menú degustación previo y cocina mediterránea propia",
      "Coordinador dedicado y presupuesto cerrado en 48 horas",
    ],
    faqTitle: "Sobre celebrar la boda en el hotel",
    cta: { title: "Cuéntanos cómo imagináis vuestra boda", text: "Decidnos la fecha aproximada, el número de invitados y lo que tenéis en mente; os respondemos con una propuesta en 48 horas." },
    related: [
      { to: "weddings", label: "Bodas en el hotel" },
      { to: "events", label: "Eventos y celebraciones" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Salón de Banquetes" },
    ],
  },
};

export default es;
